import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'fallbackOpeningHours',
  initialState: null as null | string,
  reducers: {
    setFallbackOpeningHours(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFallbackOpeningHours } = slice.actions;

export default slice.reducer;
